import { useCallback } from 'react';

import { usePsfPromoteOrSharePageData } from '#src/app/pages/psf/promoteOrShare/pageContext';
import type { ShareActionsOptions, ShareChannel } from '#src/app/shared/hooks/share';

import { useCreateNewShare } from './useCreateNewShare';
import { useRedirect } from './useRedirect';
import { useTrackPromotionShare } from './useTrackPromotionShare';

export function useOnShareSuccess(): ShareActionsOptions<ShareChannel>['onSuccess'] {
	const {
		data: { promoteShareOnComboExperiment, psfComboRemoveAutoProgressionExperiment },
	} = usePsfPromoteOrSharePageData();
	const trackPromotionShare = useTrackPromotionShare();
	const createNewShare = useCreateNewShare();
	const redirect = useRedirect();

	const { variation: autoProgressionVariation } = psfComboRemoveAutoProgressionExperiment;
	const skipCopyRedirect = autoProgressionVariation === 'variant_1' || autoProgressionVariation === 'variant_3';
	const skipSocialRedirect = autoProgressionVariation === 'variant_2' || autoProgressionVariation === 'variant_3';

	return useCallback(
		async (channel: ShareChannel) => {
			// awaiting to make sure it's done before navigating
			await Promise.all([trackPromotionShare(), createNewShare(channel)]);

			if (promoteShareOnComboExperiment.variation === 'variant_2') return;
			if (channel === 'copy' && skipCopyRedirect) return;
			if (channel !== 'copy' && skipSocialRedirect) return;

			redirect(channel);
		},
		[
			promoteShareOnComboExperiment.variation,
			skipCopyRedirect,
			skipSocialRedirect,
			trackPromotionShare,
			createNewShare,
			redirect,
		],
	);
}
